import { useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { useRouteMatch } from "../../hooks/useRouteMatch";
import { CutoffTimer } from "../CutoffDate/CutoffTimer";
import IconBreadcrumbs from "../TopBar/Breadcrumbs";
import { LoggedOutNav } from "./LoggedOutNav";
export const useNavBar = (linksContent, showTopBar) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const theme = useTheme();
    const { isAccountSection } = useRouteMatch();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    // Only Show Hamburger Menu on mobile
    const showMobileHamburgerMenu = !isDesktop && (isAccountSection || (linksContent === null || linksContent === void 0 ? void 0 : linksContent.type) === LoggedOutNav);
    const showLinksContentOutsideToolbar = showTopBar &&
        ((linksContent === null || linksContent === void 0 ? void 0 : linksContent.type) === IconBreadcrumbs || (linksContent === null || linksContent === void 0 ? void 0 : linksContent.type) === CutoffTimer) &&
        !isDesktop &&
        !isAccountSection;
    const showLinksContentInsideToolbar = isDesktop && !isAccountSection;
    return {
        isAccountSection,
        isDesktop,
        isDrawerOpen,
        setIsDrawerOpen,
        showLinksContentOutsideToolbar,
        showLinksContentInsideToolbar,
        showMobileHamburgerMenu,
    };
};
